var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: [
        _vm.buttonColor,
        {
          button: true,
          "button--fullWidth": _vm.fullWidth,
          "button--outline": _vm.outline,
          "button--small": _vm.small,
          "button--hover": _vm.hovered,
          "button--transparent": _vm.transparent
        }
      ]
    },
    [_vm._t("default", [_vm._v("Submit")])],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9eeefe66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eeefe66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Button.vue
// module id = null
// module chunks = 